// extracted by mini-css-extract-plugin
export var headerCell = "_4d-1";
export var loadingSpinnerContainer = "_4d-4";
export var rowWrapper = "_4d-3";
export var standaloneTable = "_4d-5";
export var table = "_4d-0";
export var white = "_4d-2";